import { render, staticRenderFns } from "./WritingSection.vue?vue&type=template&id=63d0cc0e&scoped=true&"
import script from "./WritingSection.vue?vue&type=script&lang=js&"
export * from "./WritingSection.vue?vue&type=script&lang=js&"
import style0 from "./WritingSection.vue?vue&type=style&index=0&id=63d0cc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0cc0e",
  null
  
)

export default component.exports